import { render, staticRenderFns } from "./terms-agree.vue?vue&type=template&id=3b325bcc"
import script from "./terms-agree.vue?vue&type=script&lang=js"
export * from "./terms-agree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports